/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum ControlsLtlFreight {
  No = "no",
  Unknown = "unknown",
  Yes = "yes",
}

export function instanceOfControlsLtlFreight(value: any): boolean {
  for (const key in ControlsLtlFreight) {
    if (Object.prototype.hasOwnProperty.call(ControlsLtlFreight, key)) {
      if (
        ControlsLtlFreight[key as keyof typeof ControlsLtlFreight] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function ControlsLtlFreightFromJSON(json: any): ControlsLtlFreight {
  return ControlsLtlFreightFromJSONTyped(json, false);
}

export function ControlsLtlFreightFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ControlsLtlFreight {
  return json as ControlsLtlFreight;
}

export function ControlsLtlFreightToJSON(
  value?: ControlsLtlFreight | null,
): any {
  return value as any;
}

export function ControlsLtlFreightToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): ControlsLtlFreight {
  return value as ControlsLtlFreight;
}
